// extracted by mini-css-extract-plugin
module.exports = {"root":"PrivacyPolicy_root__2pBDF","lastUpdated":"PrivacyPolicy_lastUpdated__2zDLP","disc":"PrivacyPolicy_disc__2X9to","title":"PrivacyPolicy_title__myD5v"};